var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AfterViewInit, ElementRef, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { environmentOm } from '../../../../environment-om';
import { ReportsApi } from '../../../api/reports-api';
import { ReportHelper } from '../../report-helper';
export class ProjectStatusReportComponent {
    constructor(reportHelper, reportsApi, route, titleService) {
        this.reportHelper = reportHelper;
        this.reportsApi = reportsApi;
        this.route = route;
        this.defaultBasemap = {
            tileUrl: environmentOm.basemapURL + '/rest/services/basemaps/penndotbasemap/MapServer/tile',
            thumbnailTile: '/7/48/36',
            tileTemplate: '/{level}/{row}/{col}',
            title: 'PennDOT'
        };
        this.tipYears = [];
        this.isGenerating = false;
        this.error = false;
        this.errorMessage = this.reportHelper.reportErrorMessages.noReportData;
        this.todaysDate = new Date().toDateString();
        titleService.setTitle(titleService.getTitle() + ' : Project Status Report');
    }
    ngOnInit() {
        this.isGenerating = true;
        this.route.paramMap.subscribe((x) => __awaiter(this, void 0, void 0, function* () {
            this.projectId = JSON.parse(window.localStorage.getItem(x.get('id'))).projectId;
            yield this.loadReport();
            this.isGenerating = false;
        }));
    }
    ngAfterViewInit() {
        this.loadMap();
    }
    loadMap() {
        return __awaiter(this, void 0, void 0, function* () {
            const layerId = environmentOm.layers.filter(x => x.name === 'mpmsProjectsAll')[0].id;
            try {
                yield this.mapRef.nativeElement.ready;
                yield this.mapRef.nativeElement.setBasemapsFromConfig(this.defaultBasemap);
                const layerSettings = [{
                        id: layerId,
                        query: {
                            operator: 'AND', subqueries: [
                                { field: 'project_id', operator: '=', value: this.projectId }
                            ]
                        },
                        zoomToLayer: true
                    }];
                this.mapRef.nativeElement.LayerService.addMapcoreLayersToMap(layerSettings);
            }
            catch (error) { }
        });
    }
    loadReport() {
        this.isGenerating = true;
        return this.reportsApi.getProjectStatusReportData(this.projectId).then((reportData) => {
            this.reportData = reportData;
            this.projectStatus = reportData.projectStatus;
            this.costData = reportData.costData;
            this.totals = reportData.costTotals;
            if (this.costData && this.costData.length) {
                this.calcTipYears(parseInt(this.costData[0].firstYear, 10));
            }
            this.isGenerating = false;
        }, (error) => {
            this.isGenerating = false;
            this.error = true;
        });
    }
    calcTipYears(first) {
        let x;
        const maxIndex = 4;
        for (let i = 0; i < maxIndex; i++) {
            x = parseInt(first, 10) + i;
            this.tipYears.push(x);
        }
    }
}
